export const base_url = window.location.origin;
export const confirmMessage = "Are you sure you want to do this?";
export const CASH_CONDITIONS = [
    'MIXED',
    'FIT',
    'SOILED'
];
export function removeTableRow() {
    $('.remove-btn').on('click', function (e) {
        e.preventDefault();
        $(this).closest('tr').remove();
    })
}

export function buildSelectOptions(data) {
    let str = "";
    for (let i = 0; i < data.length; i++) {
        str = str+`<option value="${data[i].id}">${data[i].name}</option>`
    }
    return str;
}

export function buildSelectCashConditions() {
    var placeHolder = '<option value="">Choose...</option>';
    var str = "";
    for (let i = 0; i < CASH_CONDITIONS.length; i++) {
        str = str+`<option value="${CASH_CONDITIONS[i]}">${CASH_CONDITIONS[i]}</option>`
    }
    return `<select name="cashCondition" required class="form-control">${placeHolder}${str}</select>`;
}

// Function to get all parameters from the current URL
export function getURLParameters() {
    var parameters = {};
    var queryString = window.location.search.substring(1); // Get the query string without the leading '?'

    // Split the query string into key-value pairs
    var pairs = queryString.split('&');

    // Iterate through each pair and populate the parameters object
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1] || '');

        // Handle cases where a parameter appears multiple times (e.g., ?param=value1&param=value2)
        if (parameters[key]) {
            if (Array.isArray(parameters[key])) {
                parameters[key].push(value);
            } else {
                parameters[key] = [parameters[key], value];
            }
        } else {
            parameters[key] = value;
        }
    }

    return parameters;
}


